// extracted by mini-css-extract-plugin
module.exports = {"container":"privacy_container__FYIin","innercontainer":"privacy_innercontainer__PlqyU"};